import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { CreateMasterDTO, MaterialApiService } from 'features/material-details/api/material-api.services';
import { queryClient } from 'providers';

import { MaterialQueryKeys } from './query-keys';
const { createMatrial } = MaterialApiService();
export const useCreateMatrialDetails = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: CreateMasterDTO) => {
      return createMatrial(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data: any) => {
        queryClient.invalidateQueries({
          queryKey: MaterialQueryKeys.lists(),
        });
        if (data?.rs == 2) {
          message.error(data?.msgkey)
        } else {
          message.success(data?.customMessage)
        }
      }
    },
  );
};










